export const tool = {
  name: 'download-image',
  description: 'A tool that modifies the 3D model’s screenshot and recipe (JSON of IModel)',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      message: {
        type: 'string',
        default: 'Modify model structure',
      },
    },
    required: ['message'],
  },
};
